export default __webpack_public_path__ + "static/media/momo05.e790bbc3.png";